<template>
    <div class="edit-payment">
        <PageContent class="batch-edit-wrapper">
            <span class="summary-title">
                Please review and confirm your submission
            </span>
            <PanelV2
                type="w6"
                title=""
                @nextClick="saveForms()"
                mode="edit"
            >
                <template v-slot:title-solt>
                </template>
                <template v-slot:content-solt>
                    <h2>BDO Payment Solutions</h2>
                    <p class="blue">Which BDO Payment solutions are you applying for?</p>
                    <p>You may choose 1 or more products from the digital/physical store options.</p>
                    <BdoCheckbox :checkboxList="box1" @checkboxClick="checkbox1Click" />
                    <p class="line"></p>
                    <p class="blue">Which BDO Payment solutions are you applying for?</p>
                    <p>You may choose 1 or more products from the digital/physical store options.</p>
                    <BdoCheckbox :checkboxList="box2" @checkboxClick="checkbox2Click" />
                </template>
            </PanelV2>
        </PageContent>
    </div>
</template>

<script>
    import BdoCheckbox from "../components/BdoCheckbox.vue"
    import API from "@/api";
    export default {
        name: 'EditPayment',
        components:{
            BdoCheckbox
        },
        data() {
            return {
                digitalPaymentList: [],
                physicalPaymentList: []
            }
        },
        created() {
            this.init()
        },
        computed: {
            box1() {
                return this.digitalPaymentList
            },
            box2() {
                return this.physicalPaymentList
            }
        },
        methods: {
            init() {
                API.getBdoProcessData({
                    token: this.getCookieItem('token'),
                    pageNo: 999,
                }).then((res) => {
                    this.digitalPaymentList = res.obj.digitalPayment.digitalPaymentList
                    this.physicalPaymentList = res.obj.physicalPayment.physicalPaymentList
                })
            },
            checkbox1Click(val) {
                this.digitalPaymentList = val
            },
            checkbox2Click(val) {
                this.physicalPaymentList = val
            },
            saveForms() {
                if (this.digitalPaymentList.every(val => val.chooseFlag == '2') && this.physicalPaymentList.every(val => val.chooseFlag == '2')) {
                    this.showMessageTip('You may choose 1 or more products from the digital/physical store options.')
                    return
                }
                API.editBdoProcess({
                    token: this.getCookieItem('token'),
                    pageNo: '1,2',
                    digitalPayment: {
                        digitalPaymentList: this.digitalPaymentList
                    },
                    physicalPayment: {
                        physicalPaymentList: this.physicalPaymentList
                    }
                }).then(res => {
                    if(res.success) {
                        window.history.go(-1);
                    }
                })
            }
        }
    }
</script>


<style lang="scss" scoped>
.edit-payment {
    .panel-v2.content-area {
        margin: 16px 0;
    }
    ::v-deep.content {
        padding: 0;
    }
    h2 {
        font: normal normal normal 20px/24px Nunito-bold;
        letter-spacing: 0px;
        color: #2E2E2E;
        margin-bottom: 18px;
        width: 100%;
    }
    p {
        font: normal normal normal 16px/24px Nunito;
        letter-spacing: 0px;
        color:#2E2E2E;
        margin-bottom: 24px;
        width: 100%;
    }
    .blue {
        color: #004EA8;
        margin-bottom: 16px;
        font-family: Nunito-bold;
    }
    .line {
        border: 1px solid #E4E4E4;
        width: 100%;
        margin-top: 16px;
        margin-bottom: 32px;
    }
}
</style>
